module.exports = __webpack_public_path__ + "media/images/icon-arrow-down-02b5d8da4e3c53e8246125cde0f76c1f.svg";